import { render, staticRenderFns } from "./administratorsView.vue?vue&type=template&id=ae3a3028&scoped=true&"
import script from "./administratorsView.vue?vue&type=script&lang=js&"
export * from "./administratorsView.vue?vue&type=script&lang=js&"
import style0 from "./administratorsView.vue?vue&type=style&index=0&id=ae3a3028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3a3028",
  null
  
)

export default component.exports